module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.9fd426ac.png";